module.exports = __webpack_public_path__ + "img/academy_tech_Normal_ua.25a11093.webp";